
// 生产环境
export const API_BASE_URL_PROD = 'https://contractmanagerapi.hellouxing.com';

// 测试环境
export const API_BASE_URL_TEST = 'http://192.168.12.185:9505';

/**
 * API 配置
 */

// API基础URL
export const API_BASE_URL = API_BASE_URL_PROD;

// 上传文件URL
export const UPLOAD_URL = 'https://uploadfile.hellouxing.com/uploadfile/upload';

// 合同相关接口
export const CONTRACT_URLS = {
  // 获取合同PDF
  GET_CONTRACT_PDF: `${API_BASE_URL}/system/contract/getContractPdf`,
  // 获取账单PDF
  GET_BILL_PDF: `${API_BASE_URL}/billing/getBillingPdf`,
};

export default {
  API_BASE_URL,
  UPLOAD_URL,
  CONTRACT_URLS
}; 